/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CarveOutMedicationSummary } from './CarveOutMedicationSummary';
import {
    CarveOutMedicationSummaryFromJSON,
    CarveOutMedicationSummaryFromJSONTyped,
    CarveOutMedicationSummaryToJSON,
} from './CarveOutMedicationSummary';
import type { CarveOutTrackingListEntryLead } from './CarveOutTrackingListEntryLead';
import {
    CarveOutTrackingListEntryLeadFromJSON,
    CarveOutTrackingListEntryLeadFromJSONTyped,
    CarveOutTrackingListEntryLeadToJSON,
} from './CarveOutTrackingListEntryLead';
import type { CarveOutTrackingListEntryPayer } from './CarveOutTrackingListEntryPayer';
import {
    CarveOutTrackingListEntryPayerFromJSON,
    CarveOutTrackingListEntryPayerFromJSONTyped,
    CarveOutTrackingListEntryPayerToJSON,
} from './CarveOutTrackingListEntryPayer';
import type { PalAuthPlatformPayorForm } from './PalAuthPlatformPayorForm';
import {
    PalAuthPlatformPayorFormFromJSON,
    PalAuthPlatformPayorFormFromJSONTyped,
    PalAuthPlatformPayorFormToJSON,
} from './PalAuthPlatformPayorForm';

/**
 * 
 * @export
 * @interface CarveOutTrackingListEntry
 */
export interface CarveOutTrackingListEntry {
    /**
     * 
     * @type {string}
     * @memberof CarveOutTrackingListEntry
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CarveOutTrackingListEntry
     */
    lead_id: string;
    /**
     * 
     * @type {CarveOutTrackingListEntryLead}
     * @memberof CarveOutTrackingListEntry
     */
    lead?: CarveOutTrackingListEntryLead;
    /**
     * 
     * @type {CarveOutTrackingListEntryPayer}
     * @memberof CarveOutTrackingListEntry
     */
    payer?: CarveOutTrackingListEntryPayer;
    /**
     * 
     * @type {PalAuthPlatformPayorForm}
     * @memberof CarveOutTrackingListEntry
     */
    auth_platform_form?: PalAuthPlatformPayorForm;
    /**
     * 
     * @type {Array<CarveOutMedicationSummary>}
     * @memberof CarveOutTrackingListEntry
     */
    medications: Array<CarveOutMedicationSummary>;
    /**
     * Sum of cost_per_day across this submission's non-deleted carve-out medications.
     * @type {number}
     * @memberof CarveOutTrackingListEntry
     */
    total_daily_cost: number;
}

/**
 * Check if a given object implements the CarveOutTrackingListEntry interface.
 */
export function instanceOfCarveOutTrackingListEntry(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "lead_id" in value;
    isInstance = isInstance && "medications" in value;
    isInstance = isInstance && "total_daily_cost" in value;

    return isInstance;
}

export function CarveOutTrackingListEntryFromJSON(json: any): CarveOutTrackingListEntry {
    return CarveOutTrackingListEntryFromJSONTyped(json, false);
}

export function CarveOutTrackingListEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarveOutTrackingListEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'lead_id': json['lead_id'],
        'lead': !exists(json, 'lead') ? undefined : CarveOutTrackingListEntryLeadFromJSON(json['lead']),
        'payer': !exists(json, 'payer') ? undefined : CarveOutTrackingListEntryPayerFromJSON(json['payer']),
        'auth_platform_form': !exists(json, 'auth_platform_form') ? undefined : PalAuthPlatformPayorFormFromJSON(json['auth_platform_form']),
        'medications': ((json['medications'] as Array<any>).map(CarveOutMedicationSummaryFromJSON)),
        'total_daily_cost': json['total_daily_cost'],
    };
}

export function CarveOutTrackingListEntryToJSON(value?: CarveOutTrackingListEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lead_id': value.lead_id,
        'lead': CarveOutTrackingListEntryLeadToJSON(value.lead),
        'payer': CarveOutTrackingListEntryPayerToJSON(value.payer),
        'auth_platform_form': PalAuthPlatformPayorFormToJSON(value.auth_platform_form),
        'medications': ((value.medications as Array<any>).map(CarveOutMedicationSummaryToJSON)),
        'total_daily_cost': value.total_daily_cost,
    };
}

